import { getBot } from './public/bot';
import { getAllBots } from './public/bots';
import { getGrid, getGridFilters } from './public/grid';
export { api } from './client';
export { apiTags } from './names';
export {
	GRID_PER_PAGE,
	SPECIAL_CARD,
	transformGridFilters,
} from './public/grid';

export const publicApi = {
	getBot,
	getAllBots,
	getGrid,
	getGridFilters,
};
